import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { MembershipOptionService } from './membership-option.service';
import { LoggingService } from '../../shared/services/core/logging.service';

@Injectable({ providedIn: 'root' })
export class RegistrationMembershipOptionResolver {
  constructor(private membershipOptionService: MembershipOptionService, private loggingService: LoggingService) {}

  resolve(route: ActivatedRouteSnapshot) {
    this.loggingService.info('resolving membership options for wizard');
    return this.membershipOptionService.fetchRegistrationMembershipOptions();
  }
}
